import { StyleSheet } from 'react-native';
import { VIEW_BORDER_RADIUS} from "@/constants/Styles";
import { PLACEHOLDER_IMAGE } from "@/constants/Core";
import { Image, ImageBackground } from 'expo-image';
import { useTranslation } from '@/hooks/useTranslation';

const CardImage = (props) => {

    const {
        url = null,
        alt = null,
        children = null,
        style = null,
        loading = 'eager',
        ...rest
    } = props;
    
    const { t } = useTranslation();

    if (children != null) {
        return (
            <ImageBackground 
                style={{...styles.image, ...style}} 
                resizeMethod='resize'
                contentFit='cover'
                placeholder={PLACEHOLDER_IMAGE}
                source={{uri: url}}
                accessibilityLabel={t(alt) || alt}
                loading={loading}
            >
                {children}
            </ImageBackground>
        )
    }
    
    return (
        <Image
            style={[styles.image, style]} 
            placeholder={PLACEHOLDER_IMAGE}
            contentFit='cover'
            source={{uri: url}}
            accessibilityLabel={t(alt) || alt}
            loading={loading}
        />
    );


}

const styles = StyleSheet.create({
    image: {
        aspectRatio: 1,
        borderTopLeftRadius: VIEW_BORDER_RADIUS,
        borderTopRightRadius: VIEW_BORDER_RADIUS,
        overflow: 'hidden'
    },
    noBorderRadius: {
        aspectRatio: 1,
        overflow: 'hidden'
    }
});

export default CardImage;